import { useEffect, useState, useRef } from "react";
import { Button, Form, Image, Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Validation from "../../../hooks/Validation";
import { createUpdateClient } from "../../../store/actions/clientsAction";
import Popup from "../../common/modal/Popup";

// import ProfileImage from "../../../assets/images/logo_placeholder.jpg";
import ProfileImage from "../../../assets/images/photo.svg";
import Loader from "../../common/loader/Loader";
import ApiResponsePopup from "../../common/modal/ApiResponsePopup";

const formElements = [
  {
    key: "location",
    label: "Geography",
    placeHolder: "Select Geography",
    type: "select",
    options: ["MID (Provide)", "South West (NELFT)", "South East (EPUT)"],
  },
  {
    key: "wardName",
    label: "Ward Name",
    placeHolder: "Enter ward name",
    type: "text",
  },

  {
    key: "wardType",
    label: "Ward Type",
    placeHolder: "Enter Ward Type",
    type: "select",
    options: ["Virtual Ward", "Physical Ward", "Respiratory Ward"],
  },

  {
    key: "beds",
    label: "Number of Beds",
    placeHolder: "Enter no. of beds",
    type: "text",
  },
];

const ManageWard = (props) => {
  const { selectClient } = props;
  const [isUploading, setIsUploading] = useState(false);
  console.log("selectClient", selectClient);
  const [logo, setLogo] = useState(null);
  const [logoUrl, setLogoUrl] = useState(null);
  const [isShow, setIsShow] = useState(false);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const inputRef = useRef();
  const [clientDetail, setClientDetail] = useState({
    clientName: null,
    contactName: null,
    clientEmail: null,
  });
  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    Validation({
      clientName: clientDetail?.clientName,
      contactName: clientDetail?.contactName,
      clientEmail: clientDetail?.clientEmail,
    });
  const dispatch = useDispatch();
  const { error: apiError, isLoader } = useSelector((state) => state.clients);

  useEffect(() => {
    if (selectClient === null) {
      setClientDetail({
        clientName: null,
        contactName: null,
        clientEmail: null,
      });
      setLogoUrl(null);
    } else {
      setClientDetail({
        clientId: selectClient.clientId,
        clientName: selectClient.clientName,
        contactName: selectClient.contactName,
        clientEmail: selectClient.clientEmail,
      });
      setLogoUrl(selectClient.logo);
    }
  }, [selectClient]);

  const submitHandler = (e) => {
    e.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    console.log("file logo", logo);
    setIsUploading(true);
    let formData = new FormData();
    if (clientDetail.clientId) {
      formData.append("clientId", clientDetail.clientId);
    }
    formData.append("clientName", clientDetail.clientName);

    formData.append("contactName", clientDetail.contactName);
    formData.append("clientEmail", clientDetail.clientEmail);
    if (logo) {
      formData.append("logo", logo);
    }
    console.log("formData-", ...formData);

    if (!isError() && error !== null && isActionCalled) {
      dispatch(createUpdateClient(formData)).then(({ payload }) => {
        console.log("payload-", payload);
        if (payload.success) {
          setIsUploading(true);
          hideHandler();
        } else {
          setIsShow(true);
        }
      });
      setIsActionCalled(false);
      inputRef.current.value = "";
    }
    setIsActionCalled(false);
  }, [isActionCalled]);

  const hideHandler = () => {
    resetAllValidator();
    props.onHide();
    if (selectClient === null) {
      setClientDetail({
        clientName: null,
        contactName: null,
        clientEmail: null,
      });
      setLogoUrl(null);
    } else {
      setClientDetail({
        clientId: selectClient.clientId,
        clientName: selectClient.clientName,
        contactName: selectClient.contactName,
        clientEmail: selectClient.clientEmail,
      });
      setLogoUrl(selectClient.logo);
    }
  };

  const hideHandlerRes = () => {
    setIsShow(false);
  };

  const upload = (e) => {
    console.log(e.target.files[0]);
    setLogo(e.target.files[0]);
  };
  useEffect(() => {
    if (logo) {
      let urllink = URL.createObjectURL(logo);
      console.log("urllink", urllink);
      setLogoUrl(urllink);
    }
  }, [logo]);

  const { onHide, ...props1 } = props;

  return (
    <>
      <Popup
        {...props1}
        onHide={hideHandler}
        size="md"
        footer={
          <>
            <Button
              variant="outline-secondary model-btn" className="me-4"
              onClick={(e) => hideHandler(e)}
            >
              Cancel
            </Button>
            <Button
              className="btn-primary model-btn"
              onClick={(e) => submitHandler(e)}
            >
              {selectClient ? "Update" : "Add"}
            </Button>
          </>
        }
      >
        {isLoader && <Loader />}

        {formElements.map((element, i) => {
          return (
            (!selectClient || element.key !== "password") && (
              <Form.Group className="mb-4" controlId="formBasicEmail" key={i}>
                <Form.Label>
                  {element.label} <span className="required">*</span>
                </Form.Label>
                {element.type == "select" ? (
                  <Form.Select aria-label="Default select example">
                    <option  value="">Select</option>
                    {element.options.map((item) => (
                      <option value={item}> {item} </option>
                    ))}
                  </Form.Select>
                ) : (
                  <>
                    <Form.Control
                      type={element.type}
                      name={element.key}
                      placeholder={element.placeHolder}
                      value={clientDetail && clientDetail[element.key]}
                      onChange={async (e) => {
                        setClientDetail({
                          ...clientDetail,
                          [element.key]: e.target.value,
                        });
                        resetValidator(e.target.name);

                        console.log("clientDetail", clientDetail);
                      }}
                      isInvalid={error && error[element.key]}
                    />

                    <Form.Control.Feedback type="invalid">
                      {error && error[element.key]}
                    </Form.Control.Feedback>
                  </>
                )}
              </Form.Group>
            )
          );
        })}
        <ApiResponsePopup
          {...{
            hideHandlerRes,
            isRecordUpdated: isShow,
            title: "Manage Client",
            successMsg: successMessage,
            errorRes: apiError?.message,
          }}
        />
      </Popup>
    </>
  );
};

export default ManageWard;
